import { getUrlToWidget } from './get-url-to-widget';
export const getUrlToChannel = _ref => {
  let {
    siteUrl,
    compId
  } = _ref;
  return getUrlToWidget(siteUrl, compId);
};
//# sourceMappingURL=get-url-to-channel.js.map